import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { images } from '../../data/images';
export function AnimatedLogo() {
  const reduce = useReducedMotion();
  const loop = (duration: number) => ({
    duration,
    repeat: Infinity,
    ease: 'easeInOut' as const
  });
  return <div className="relative mx-auto aspect-square w-64 sm:w-80 lg:w-[440px]" data-id="element-534" data-mp="2nw70oakhbyek">
      {/* Halo neón pulsante */}
      <motion.div aria-hidden className="absolute inset-[4%] rounded-full" style={{
      boxShadow: '0 0 70px 10px rgba(20, 99, 255, 0.45), inset 0 0 30px rgba(20, 99, 255, 0.25)'
    }} animate={reduce ? undefined : {
      opacity: [0.45, 1, 0.45]
    }} transition={loop(3.2)} data-id="element-535" data-mp="205tdoygr4pqu" />

      {/* Arcos de luz que orbitan el logo */}
      <motion.svg aria-hidden viewBox="0 0 100 100" className="absolute inset-0 h-full w-full" animate={reduce ? undefined : {
      rotate: 360
    }} transition={{
      duration: 12,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-536" data-mp="253cvg8cnrknj">
        <circle cx="50" cy="50" r="49" fill="none" stroke="#3D7EFF" strokeWidth="0.7" strokeLinecap="round" strokeDasharray="46 262" style={{
        filter: 'drop-shadow(0 0 1.5px #1463FF)'
      }} data-id="element-537" data-mp="5sasz5qecm01" />
        <circle cx="50" cy="50" r="49" fill="none" stroke="#1463FF" strokeWidth="0.5" strokeLinecap="round" strokeDasharray="14 294" strokeDashoffset="-154" opacity="0.8" data-id="element-538" data-mp="ele0kxed24mr" />
      </motion.svg>

      {/* Logo recortado en círculo: elimina el fondo blanco de la imagen */}
      <motion.div className="absolute inset-[4%]" initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-539" data-mp="3n1ha78p1a3dq">
        <motion.img src={images.logo} alt="VCARS — 0 km multimarca" className="h-full w-full object-cover" style={{
        clipPath: 'circle(48.6% at 50% 50%)'
      }} animate={reduce ? undefined : {
        y: [0, -6, 0]
      }} transition={loop(5)} data-id="element-540" data-mp="ushb7kzvsoc" />
      </motion.div>
    </div>;
}